import Vue from 'vue';
import store from './../../store';
import orderTypeTransformer from './../../transformers/orderType';

const success = ({ data }, resolve) => {
  const orderTypes = orderTypeTransformer.fetchCollection(data.data);

  store.dispatch('fetchOrderTypes', orderTypes);
  resolve();
};

const failed = (error, reject) => reject(error);

// Display order types.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('order_types')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/orderType/all.js